<template>
  <SfModal
    v-if="showModal"
    class-name="sf-modal sf-modal-xs"
    hide-close="true"
    @close="closeModal"
  >
    <template #title>
      {{ modalTitle }}
    </template>
    <template #body>
      <div class="tw-px-12">
        <div class="tw-mb-4">
          <span v-dompurify-html="modalInfoLabel1"></span>
        </div>
        <div class="tw-mb-4">
          <span v-dompurify-html="modalInfoLabel2"></span>:
        </div>
        <div class="tw-mb-2">
          <span
            class="
              sf-icon
              tw-text-lg
              fa fa-check-circle
              tw-text-sf-success-light-1
            "
          ></span>
          {{ modalListItem1 }}
        </div>
        <div class="tw-mb-2">
          <span
            class="
              sf-icon
              tw-text-lg
              fa fa-check-circle
              tw-text-sf-success-light-1
            "
          ></span>
          {{ modalListItem2 }}
        </div>
        <div class="tw-mb-2">
          <span
            class="
              sf-icon
              tw-text-lg
              fa fa-check-circle
              tw-text-sf-success-light-1
            "
          ></span>
          {{ modalListItem3 }}
        </div>
        <div class="tw-mb-12">
          <span
            class="
              sf-icon
              tw-text-lg
              fa fa-check-circle
              tw-text-sf-success-light-1
            "
          ></span>
          {{ modalListItem4 }}
        </div>
        <div class="tw-mb-2 tw-flex tw-items-center tw-justify-center tw-gap-4">
          <SfButtonDs
            variant="primary"
            data-heap="premium-cr-ok"
            @click="closeModal"
          >
            {{ modalOkButton }}
          </SfButtonDs>
        </div>
      </div>
    </template>
  </SfModal>
</template>

<script type="text/javascript">
import { SfModal } from '@app/shared/vue/components/sf-modal'
import SfButtonDs from '@app/shared/vue/components/sf-button/sf-button-ds.vue'

export default {
  name: 'CustomReportingModal',
  components: { SfModal, SfButtonDs },
  data() {
    return {
      showModal: true,
    }
  },
  computed: {
    modalTitle() {
      return I18n.t('shared.premium_feature')
    },

    modalInfoLabel1() {
      return I18n.t('reporting_tiers.custom_reporting_modal.info_1')
    },

    modalInfoLabel2() {
      return I18n.t('reporting_tiers.custom_reporting_modal.info_2')
    },

    modalListItem1() {
      return I18n.t('reporting_tiers.custom_reporting_modal.list_1')
    },

    modalListItem2() {
      return I18n.t('reporting_tiers.custom_reporting_modal.list_2')
    },

    modalListItem3() {
      return I18n.t('reporting_tiers.custom_reporting_modal.list_3')
    },

    modalListItem4() {
      return I18n.t('reporting_tiers.custom_reporting_modal.list_4')
    },

    modalOkButton() {
      return I18n.t('reporting_tiers.custom_reporting_modal.ok_button')
    },
  },
  methods: {
    openModal() {
      this.showModal = true
    },
    closeModal() {
      this.showModal = false
    },
  },
}
</script>
